export function formatMesafeKm(km, gidisDonus) {
  const n = parseFloat(km);
  if (!Number.isFinite(n) || n <= 0) return '—';
  const base = `${n.toFixed(2)} km`;
  return gidisDonus === true ? `${base} (Gidiş-Dönüş)` : base;
}

export function formatMesafeBaslik(gidisDonus) {
  return gidisDonus === true ? 'Mesafe (Gidiş-Dönüş)' : 'Mesafe';
}
